/**
 * The one place in the shell that names a module.
 *
 * The arranged section — user-owned headings, their colours, the controls to
 * rearrange them — is rendered for Fakt/FiBu and for no other module, by the
 * requester's decision (FR-029). Every other module keeps the plain two-state
 * tree it has today, and keeps it even if a release of it starts sending
 * headings.
 *
 * The binding lives here, in one file with one exported predicate, so that
 * admitting a second module later is an edit here and nowhere else. A second
 * occurrence of a module's name anywhere in the navigation is a defect, not a
 * shortcut — see spec.md FR-029a.
 *
 * Worth recording honestly: deciding from the DATA instead — render headings
 * for whichever module sends them — needs the same code and carries no named
 * exception. That was argued for and overruled; the decision is the
 * requester's and this file is the fence around it.
 */

/** Manifest id of the module whose menu the user arranges. */
const ARRANGED_MENU_MODULE = 'fakt';

/**
 * May this module's menu be rendered as an arranged section — headings,
 * accents, and the controls to rearrange them?
 *
 * A `true` here is permission, not obligation. Within Fakt/FiBu the rendering
 * still follows the data: a release that publishes a plain tree renders as a
 * plain tree, never as an empty section (FR-029b). The sidebar asks this
 * question first and the data second.
 */
export function rendersArrangedMenu(moduleId: string): boolean {
  return moduleId === ARRANGED_MENU_MODULE;
}
